import 'react';
import useModelValue from './use-model-value.js';
import useName from './use-name.js';

function useValue() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var modelName = useName(name);
  var modelValue = useModelValue(modelName, defaultValue);
  return modelValue;
}

export default useValue;
//# sourceMappingURL=use-value.js.map
